import React, { useState, useEffect } from 'react'
import { selectActiveGrant, selectPendingOffer } from '@meprism/shared/src/redux/product/ProductSlice'
import { useAppSelector } from '../../../redux/storeExports'
import { Box, Typography, Button, useMediaQuery, useTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export const MpOfferHeader = () =>{
    const Theme = useTheme()
    const isMobile = useMediaQuery(Theme.breakpoints.down('sm'))
    const Navigate = useNavigate()
    const [isValidId,setIsValidId] = useState(false)
    const activeGrant = useAppSelector(selectActiveGrant)
    const offer = useAppSelector(selectPendingOffer)

    useEffect(()=>{
        if(!activeGrant && offer){
            setIsValidId(true)
        }
    },[activeGrant, offer])

    return(
        <Box sx={{display: isValidId? 'flex':'none',  background: 'linear-gradient(45deg, #B052F2 0%, #4A148C 100%)',height:isMobile?'10vh':'6vh', 
        width:'100%', alignItems:"center", justifyContent:"center", borderRadius:'5px', px:10, mb:5}}>
            <Typography variant='h3' color= '#fff' sx={{'&.MuiTypography-root': { fontWeight: 'bold' }}}>{offer?.description}</Typography>
            <Button sx={{ml:isMobile?5:10,backgroundColor:"#9f5adbff", color:"#fff", fontSize:'12px', borderRadius:'0px','&:hover': {background: 'white', color: '#9135E0'},}}
            onClick={()=>{
                Navigate('/subscription', {replace:true})
            }}
            >
                Redeem Now
            </Button>
        </Box>
    )
}